export const SUPPORT_SESSION_KEY = 'tivedo.support_session_id'

/**
 * Seam 7. On first paint of a support window the URL carries a one-time
 * `?__support=<sessionId>` token. Persist it to PER-WINDOW sessionStorage (never
 * cookie/localStorage — that is what makes the override window-scoped) and strip
 * it from the URL so it is not bookmarked/shared. Runs once at bootstrap, before
 * the first /me fetch, via provideAppInitializer.
 */
export function seedSupportCredentialFromUrl(): void {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return
  const params = new URLSearchParams(window.location.search)
  const token = params.get('__support')
  if (!token) return
  sessionStorage.setItem(SUPPORT_SESSION_KEY, token)
  params.delete('__support')
  const qs = params.toString()
  const url = window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash
  window.history.replaceState({}, '', url)
}
